import { Box, Flex } from 'grid-styled'
import * as React from 'react'
import Chat from 'react-icons/lib/fa/comment'
import Envelope from 'react-icons/lib/fa/envelope'
import Layout from '../components/Layout'

import { Link } from 'gatsby'
import Form from '../components/Form'

import Accordion from '../components/Accordion'
import Card from '../components/Card'
import CTA from '../components/CTA'
import Header from '../components/Header'
import styled from 'styled-components'
import { yPad } from '../utils/theme'
import FAQs from '../components/FAQs'
import { Helmet } from 'react-helmet'

const ContactCards = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  ${yPad};
  padding-bottom: 0 !important;

  ${Box} {
    max-width: 450px;
  }

  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 75%;
    background-color: #f1f8fe;

    @media (min-width: 940px) {
      height: 155px;
    }
  }

  @media (max-width: 639px) {
    flex-direction: column;
    ${Box} {
      margin: 0 auto;
    }
  }
`

export const faqsInfo = [
  {
    title: 'Common questions'
  },
  {
    answer:
      'We offer a variety of different digital marketing and web services. We have expert designers and developers that can overhaul your website. Digital marketing specialists that can increase you leads and sales through a number of varying strategies.',
    question: 'How can you help me grow my business?'
  },
  {
    answer:
      'We offer Search Engine Optimisation (SEO) to increase your organic traffic and sales in a long term sustainable manner. Google Ads to help you get instant results in a proven and reliable manner. Social media marketing to advertise on the biggest platforms in the history of humanity. We also offer web services such as Website design, development and hosting to make your overall online life simpler.',
    question: 'What services do you offer?'
  },
  {
    answer: `We are official Google Partners, our team are all qualified Google Ads (AdWords) experts. We have direct relationships with Facebook developers and marketing experts to stay up to date on the latest changes. And our programmers have built websites for some of Brisbane's most well known businesses. On top of all this, at the end of the day, the results speak for themselves.`,
    question: 'What are you qualifications?'
  },
  {
    answer: `It's simple. Just give us a call or shoot us an email to say hi and we'll get back to you as soon as we can to set up your obligation free (and just free) strategy consultation.`,
    question: 'How do I get started?'
  }
]

const openChat = () => drift.api.sidebar.open()

export default () => (
  <Layout>
    <Helmet>
      <title>Digital Growth Agency - Contact Turboclicks</title>
      <meta
        name="description"
        content="Want to radically boost your business growth. Contact Turboclicks to learn about our customised digital growth strategies."
      />
    </Helmet>
    <Header>
      <h1>We&rsquo;ve got your back</h1>
    </Header>
    <ContactCards>
      <Box mx={3}>
        <Link to="#form">
          <Card
            shadow={true}
            border={true}
            color="primary"
            title="Send an email"
            content="Have a question, or want to find out what we can do for your business? Email us at any time and we'll get back to you shortly."
          >
            <Envelope />
          </Card>
        </Link>
      </Box>
      <Box mx={3} onClick={openChat}>
        <Link to="#">
          <Card
            shadow={true}
            border={true}
            color="tertiary"
            title="Start a chat"
            content="This isn't the 90s. Don't want to email, we can chat live, right here. Let's work through your questions in real time..."
          >
            <Chat />
          </Card>
        </Link>
      </Box>
    </ContactCards>
    <FAQs flushTop={true} data={faqsInfo} />
    <CTA
      title="Having an issue?"
      subtitle="We’re here to help you."
      button="Contact Us"
    />
    <Form id="form" />
  </Layout>
)

// <div class="o-section o-section--flush-bottom c-support-channels">
//   <div class="o-container o-container--medium">
//     <div class="o-grid">

//     </div>
//   </div>
// </div>
